<template>
    <div class="main-content">
        <PageHeader>
            <v-col
                lg="5"
                xl="5"
                md="6"
                cols="12"
                class="p-0 d-flex flex-column justify-content-center align-items-center"
            >
                <div class="text-content" :class="textContentStyle">
                    <div class="title-text py-3" :class="titleTextStyle">
                        Pillars of Knowledge
                    </div>
                    <div class="sub-title-text" :class="subTitleTextStyle">
                        View Project Spectrum’s 8 Courses to learn more about how to keep your business Cyber Secure
                    </div>
                </div>
            </v-col>

            <v-col
                lg="7"
                xl="7"
                md="6"
                cols="12"
                class="p-0 d-flex flex-row justify-content-center align-items-center"
                :style="{ marginTop: topMarginSize }"
            >
                <div class="action-handler-items">
                    <div 
                        :style="{ width: actionItemSize }"
                        class="action-handler-item d-flex flex-row align-items-center justify-content-center justify-content-lg-start justify-content-xl-start" 
                        v-for="actionItem in actionHandlerItems" 
                        :key="actionItem.actionTitle"
                    >
                        <v-btn
                            rounded
                            large
                            dark
                            :color="'#424EC4'"
                            :width="actionItemWidth"
                            :style="{ fontSize: actionItemFontSize }"
                            @click="openCourseActionItemHandler(actionItem.actionTitle, actionItem.actionUrl)"
                        >
                            {{ actionItem.actionTitle }}
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </PageHeader>

        <section class="mt-5" id="blueprint-options-list-container">
            <div class="container-fluid">
                <v-row>
                    <v-col>
                        <div class="d-flex flex-column justify-content-start w-100">
                            <div class="d-flex flex-row justify-content-center section-title w-100">
                                <span class="m-0">VIDEO LIBRARY</span>
                            </div>
                            <div class="d-flex flex-row justify-content-center w-100">
                                <span class="project-spectrum-title m-0 text-center">View all videos discussing</span>
                            </div>
                            <div class="d-flex flex-row justify-content-center w-100">
                                <span class="project-spectrum-title m-0 text-center">our Pillars of Knowledge</span>
                            </div>
                            <div 
                                class="blueprint-options d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center"
                                :class="{
                                    'align-items-center': !isVideoTypeItemsOpened,
                                    'align-items-lg-start align-items-xl-start align-items-sm-center align-items-center': isVideoTypeItemsOpened,
                                }"
                            >
                                <div 
                                    class="blueprint-option-title"
                                    :class="{
                                        'mb-2': !isVideoTypeItemsOpened,
                                        'mt-3': isVideoTypeItemsOpened,
                                    }"
                                >
                                    {{ !videoTypeItem ? "I am here because" : "I am here because I want to watch" }}
                                </div>

                                <div 
                                    id="blueprint-options-list"
                                    class="blueprint-options-container"
                                    :class="computeBlueoptionsLeftMargin"
                                >
                                    <div 
                                        class="blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2" 
                                        @click="isVideoTypeItemsOpened = !isVideoTypeItemsOpened"
                                    >
                                        <v-container>
                                            <v-row>
                                                <v-col cols="11" class="p-0 d-flex justify-content-start align-items-center">
                                                    {{ !videoTypeItem ? "Select an option" : `more on ${selectedVideoTypeItemValue}` }}
                                                </v-col>
                                                <v-col cols="1" class="p-0 pr-1 d-flex justify-content-center">
                                                    <font-awesome-icon
                                                        style="max-width: 100% !important"
                                                        size="2x" 
                                                        :icon="isVideoTypeItemsOpened ? 'chevron-up' : 'chevron-down'"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </div>

                                    <div 
                                        v-if="isVideoTypeItemsOpened"
                                        class="blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2" 
                                        :class="{
                                            'selected-blueprint-option': option.optionItem === videoTypeItem
                                        }"
                                        v-for="option in videoTypeOptionItems" 
                                        :key="option.optionItem"
                                        @click="setVideoTypeItemOption(option.optionItem)"
                                    >
                                        {{ option.optionValue }}
                                    </div>
                                </div>

                                <div 
                                    v-if="videoTypeItem !== null" 
                                    class="d-flex flex-row justify-content-center align-items-center"
                                    :class="computeBlueoptionsLeftMargin"
                                >
                                    <v-btn
									rounded
									large
									dark
									:color="'#424EC4'"
									@click="videoTypeItem = null"
                                    >
                                        See All Videos
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </section>

        <section class="my-4">
            <!-- <VideoListItems
                :videoInfoList="videoInfoList"
                :videoSearchQuery="videoTypeItem"
                :scrollToElementId="'blueprint-options-list-container'"
                :tagColors="tagColors"
                :searchByVideoType="true"
            /> -->
        </section>

        <section class="mb-4">
            <div class="container p-3 compliance-container">
                <div class="cmmc-compliance-check">
                    <v-row>
                        <v-col
                            xl="7"
                            lg="7"
                            md="7"
                            cols="12"
                        >
                            <div class="compliance-text top-compliance-text d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start">
                                Check your CMMC Compliance Level
                            </div>
                            <div class="compliance-text bottom-compliance-text d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start my-3">
                                Take our cyber readiness assessment to determine how prepared your business is to deal with cyber-attacks.
                            </div>
                        </v-col>
                        <v-col
                            xl="5"
                            lg="5"
                            md="5"
                            cols="12"
                            class="d-flex flex-row align-items-center justify-content-center"
                        >
                            <v-btn
                                outlined
                                rounded
                                :color="'#fff'"
                                width="240"
                                height="60"
                                @click="goToTaskAssessment"
                            >
                            Start Now
                        </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <div 
            v-show="showCourseContainer" 
            class="course-container-overlay"
        >
            <div class="course-container-display" style="display:flex; justify-content: center; align-items: center;">
                <div class="close-cource-container">
                    <button 
                        type="button" 
                        class="close-course-container-button"
                        @click="showCourseContainer = false"
                    >
                        <i class="mdi mdi-close">
                        </i>
                    </button>
                </div>

                <div 
                    v-if="showCircularLoader && selectedCourseUrl"
                    class="w-100 d-flex flex-column justify-content-center align-items-center"
                >
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="'#424EC4'"
                        indeterminate
                    >
                    </v-progress-circular>
                    <span style="font-size: 18px; font-weight: 500; font-style: normal; color: black; text-align: center;">
                        {{ `Loading the ${selectedCourseItem} course....` }}
                    </span>
                </div>

                <iframe 
                    v-if="selectedCourseUrl" 
                    id="iframe-content"
                    class="course-content-iframe" 
                    :src="selectedCourseUrl" 
                    frameborder="0"
                    @load="() => iframeEndLoadHandler()"
                >
                </iframe>

                <span v-else-if="!selectedCourseUrl" style="font-size: 24px; font-weight: 700; font-style: normal; color: black; text-align: center;">{{ `The course for "${selectedCourseItem}" is yet to be provided` }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import VideoListItems from "./library/widgets/video-list-items.vue";
    import PageHeader from "./library/widgets/page-header.vue";
    import { EventBus } from "../utils/eventBus";
    export default {
        components: {
            VideoListItems,
            PageHeader,
        },
        data() {
            return {
                isVideoTypeItemsOpened: false,
                showCourseContainer: false,
                showCircularLoader: false,
                selectedCourseItem: null,
                selectedCourseUrl: null,
                videoTypeItem: null,
                tagColors: {
                    Cybersecurity: { background: "#8BC5EB", text: "#000" },
                    "Project Spectrum": { background: "#424EC4", text: "#FFF" },
                    "Spectrum Manufacturers": { background: "#00A28E", text: "#FFF" },
                    "Understanding Data": { background: "#E50088", text: "#FFF" },
                    "Business Tools": { background: "#FFFFFF", text: "#000" },
                    CMMC: { background: "#00AFF7", text: "#000" },
                    "NIST 800-171": { background: "#FF504D", text: "#FFF" },
                },
                videoTypeOptionItems: [
                    { 
                        optionItem: "Cybersecurity", 
                        optionValue: "Cybersecurity", 
                    },
                    { 
                        optionItem:"Project Spectrum", 
                        optionValue:"Project Spectrum", 
                    },
                    { 
                        optionItem:"Spectrum Manufacturers", 
                        optionValue:"Spectrum for Manufacturers", 
                    },
                    { 
                        optionItem:"Understanding Data", 
                        optionValue:"Understanding My Data", 
                    },
                    { 
                        optionItem:"Business Tools", 
                        optionValue:"Tools for My Business", 
                    },
                    { 
                        optionItem:"Business Tools 2", 
                        optionValue:"Tools for My Business 2", 
                    },
                    { 
                        optionItem:"CMMC", 
                        optionValue:"CMMC", 
                    },
                    { 
                        optionItem:"NIST 800-171", 
                        optionValue:"NIST 800-171", 
                    },
                ],
                actionHandlerItems: [
                    {
                        actionTitle: "Cybersecurity",
                        actionUrl: "https://projectspectrumlearning.io/pillars/cybersecurity/index.html#/",
                    },
                    {
                        actionTitle: "Project Spectrum",
                        actionUrl: "https://projectspectrumlearning.io/pillars/projectspectrum/index.html",
                    },
                    {
                        actionTitle: "Manufacturers",
                        actionUrl: "https://projectspectrumlearning.io/pillars/manufacturing/index.html",
                    },
                    {
                        actionTitle: "Your Data",
                        actionUrl: "https://projectspectrumlearning.io/pillars/userdata//index.html",
                    },
                    {
                        actionTitle: "Business Tools",
                        actionUrl: "https://projectspectrumlearning.io/pillars/toolsforbusiness/1/index.html",
                    },
                    {
                        actionTitle: "Business Tools 2",
                        actionUrl: "https://projectspectrumlearning.io/pillars/toolsforbusiness/2/index.html",
                    },
                    {
                        actionTitle: "What is CMMC?",
                        actionUrl: "https://projectspectrumlearning.io/pillars/cmmc/index.html",
                    },
                    {
                        actionTitle: "NIST 800-171",
                        actionUrl: "https://projectspectrumlearning.io/pillars/NIST800/index.html",
                    },
                ],
                // videoInfoList: [
                //     {
                //         title: "Cyber Awareness",
                //         content: "Gain knowledge of common threats and attack vectors",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/96e7d4dac4d6001078b6ce8ed5912bc2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F96e7d4dac4d6001078b6ce8ed5912bc2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D10s%26height%3D600",
                //         videoNum: "1.1",
                //         videoType: "Cybersecurity",
                //     },
                //     {
                //         title: "Study Best Practices",
                //         content: "Learn about fundamental cybersecurity practices such as data encryption, software updates, and password management",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/8526408ff71d724f663088320db8d080/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F8526408ff71d724f663088320db8d080%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D58s%26height%3D600",
                //         videoNum: "1.2",
                //         videoType: "Cybersecurity",
                //     },
                //     {
                //         title: "Strategies of Readiness",
                //         content: "Gain knowledge on the importance of learning cyber frameworks and standards",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/eac719cd2d4e8f95271eca8d732a3867/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Feac719cd2d4e8f95271eca8d732a3867%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D40s%26height%3D600",
                //         videoNum: "1.3",
                //         videoType: "Cybersecurity",
                //     },
                //     {
                //         title: "Kill Chain",
                //         content: "Learn about the framework developed by Lockheed Martin to help understand and counteract cyber threats",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/84c1d8a1face5b2988026e81d93d78cc/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F84c1d8a1face5b2988026e81d93d78cc%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m52s%26height%3D600",
                //         videoNum: "1.4",
                //         videoType: "Cybersecurity",
                //     },
                //     {
                //         title: "Our Core Objectives",
                //         content: "Obtain an overview of the core objectives and scope of Project Spectrum",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4a14350bed121fb184eb4dd0e7c86ef5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4a14350bed121fb184eb4dd0e7c86ef5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D14s%26height%3D600",
                //         videoNum: "2.1",
                //         videoType: "Project Spectrum",
                //     },
                //     {
                //         title: "View Case Studies",
                //         content: "Examine case studies and success stories pertaining to the utilization of Project Spectrum",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9455f5cfa31e0f90d18eb46656684c2e/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9455f5cfa31e0f90d18eb46656684c2e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D18s%26height%3D600",
                //         videoNum: "2.2",
                //         videoType: "Project Spectrum",
                //     },
                //     {
                //         title: "Resource Overview",
                //         content: "Project Spectrum many resources at your side",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d9cd68e19e5af740e90b792bb1d9390b/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd9cd68e19e5af740e90b792bb1d9390b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m25s%26height%3D600",
                //         videoNum: "2.3",
                //         videoType: "Project Spectrum",
                //     },
                //     {
                //         title: "Industry Forecasting",
                //         content: "Keep abreast of current technological advancements in the field",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/aed38f245dea01905618525faeff0830/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faed38f245dea01905618525faeff0830%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m9s%26height%3D600",
                //         videoNum: "3.1",
                //         videoType: "Spectrum Manufacturers",
                //     },
                //     {
                //         title: "Prioritize Optimization",
                //         content: "Examine automation as a means of streamlining current procedures and systems",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/b6a7b4691f7260e357f440eb12021349/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fb6a7b4691f7260e357f440eb12021349%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m8s%26height%3D600",
                //         videoNum: "3.2",
                //         videoType: "Spectrum Manufacturers",
                //     },
                //     {
                //         title: "Manufacturing Vulnerabilities",
                //         content: "Protect your operations and facilities",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/a21777f32a5b9bd686a7287f61131705/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fa21777f32a5b9bd686a7287f61131705%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D50s%26height%3D600",
                //         videoNum: "3.3",
                //         videoType: "Spectrum Manufacturers",
                //     },
                //     {
                //         title: "Identify Data Types",
                //         content: "Define the types of data the business will collect, process, and store",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/23fe2247dc7b8356f1ca09e6bc712c38/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F23fe2247dc7b8356f1ca09e6bc712c38%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D56s%26height%3D600",
                //         videoNum: "4.1",
                //         videoType: "Understanding Data",
                //     },
                //     {
                //         title: "Decision Making",
                //         content: "Consider data analysis and visualization techniques to draw conclusions from your data",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/65ce5269ae9a23bc961f8c0e104e0531/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F65ce5269ae9a23bc961f8c0e104e0531%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m41s%26height%3D600",
                //         videoNum: "4.2",
                //         videoType: "Understanding Data",
                //     },
                //     {
                //         title: "Implementation",
                //         content: "Implement governance procedure for quality, security, and compliance",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9d60180bb746b051385e9bf7a4d219a2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9d60180bb746b051385e9bf7a4d219a2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m03s%26height%3D600",
                //         videoNum: "4.3",
                //         videoType: "Understanding Data",
                //     },
                //     {
                //         title: "Essential Requirements",
                //         content: "Determine your company's unique requirements and objectives",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d4376d5a04169d5b9ae4ed14046824e6/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd4376d5a04169d5b9ae4ed14046824e6%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D51s%26height%3D600",
                //         videoNum: "5.1",
                //         videoType: "Business Tools",
                //     },
                //     {
                //         title: "Equip Yourself",
                //         content: "Research and evaluate tools specific to your industry and business size",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/2a01eb3a5e8c20225e3e9253658c81c5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F2a01eb3a5e8c20225e3e9253658c81c5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m13s%26height%3D600",
                //         videoNum: "5.2",
                //         videoType: "Business Tools",
                //     },
                //     {
                //         title: "Final Determination",
                //         content: "Selecting your final option, consider integration and cost scalability",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/832df5241c3a54e4635d48037a894212/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F832df5241c3a54e4635d48037a894212%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m24s%26height%3D600",
                //         videoNum: "5.3",
                //         videoType: "Business Tools",
                //     },
                //     {
                //         title: "What is CMMC?",
                //         content: "Learn about the CMMC program of the Department of Defense (DoD)",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/ca129ca1db7d642672672e7fab2b8cc4/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fca129ca1db7d642672672e7fab2b8cc4%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m26s%26height%3D600",
                //         videoNum: "6.1",
                //         videoType: "CMMC",
                //     },
                //     {
                //         title: "What is Level 1?",
                //         content: "Learn about the foundational tier of CMMC",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4bcb68d73d3d3f42236370a426264857/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4bcb68d73d3d3f42236370a426264857%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m20s%26height%3D600",
                //         videoNum: "6.2",
                //         videoType: "CMMC",
                //     },
                //     {
                //         title: "What is Level 2?",
                //         content: "Learn about the advanced tier of CMMC",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/91da3ee47ac59d2f4d3cbc2c30a7832f/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F91da3ee47ac59d2f4d3cbc2c30a7832f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m06s%26height%3D600",
                //         videoNum: "6.3",
                //         videoType: "CMMC",
                //     },
                //     {
                //         title: "What is NIST 800-171?",
                //         content: "Learn about a set of security framework requirements issued by DoD",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/af44010cc39f19ddc44e7976d37cb095/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faf44010cc39f19ddc44e7976d37cb095%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D22s%26height%3D600",
                //         videoNum: "7.1",
                //         videoType: "NIST 800-171",
                //     },
                //     {
                //         title: "NIST 800-171 vs CMMC Level 1",
                //         content: "What are the differences between these two?",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/05509b84b6db3c0ebadf3cd2e72d6ba0/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F05509b84b6db3c0ebadf3cd2e72d6ba0%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D57s%26height%3D600",
                //         videoNum: "7.2",
                //         videoType: "NIST 800-171",
                //     },
                //     {
                //         title: "NIST 800-171 vs CMMC Level 2",
                //         content: "What are the differences between these two?",
                //         videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/7c87af2802c6f1b3332670345477a295/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F7c87af2802c6f1b3332670345477a295%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D41s%26height%3D600",
                //         videoNum: "7.3",
                //         videoType: "NIST 800-171",
                //     },
                // ],
            };
        },
        computed: {
            actionItemSize(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) ? '50%' : '30%';
            },
            actionItemFontSize(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? '11px' : '14px';
            },
            actionItemWidth() {
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 160 : 190;
            },
            topMarginSize(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? '30px' : '0';
            },
            textContentStyle() {
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'text-content-sm-xs' : 'text-context-md-lg-xl';
            },
            titleTextStyle(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'title-text-sm-xs' : 'title-text-md-lg-xl';
            },
            subTitleTextStyle(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'sub-title-text-sm-xs' : 'sub-title-text-md-lg-xl';
            },
            computeBlueoptionsLeftMargin() {
                return this.$vuetify.breakpoint.xs ? "ml-0" : "ml-3";
            },
            selectedVideoTypeItemValue() {
                return this.videoTypeOptionItems.find(({ optionItem }) => optionItem === this.videoTypeItem)?.optionValue;
            },
        },
        methods: {
            openCourseActionItemHandler(actionItemTitle, actionItemUrl){
                this.showCircularLoader = true;
                this.selectedCourseItem = actionItemTitle;
                this.selectedCourseUrl = actionItemUrl;
                this.showCourseContainer = true;
            },
            closeCourseActionItemHandler() {
                this.showCourseContainer = false;
                this.selectedCourseItem = null;
            },
            setVideoTypeItemOption(optionItem) {
			    this.videoTypeItem = optionItem;
		    },
            goToTaskAssessment(){
                this.$router.push("cyber-readiness-check");
                EventBus.$emit("activate-indicated-menu-item", "Resources");
            },
            iframeEndLoadHandler() {
                this.showCircularLoader = false;
            },
        },
        watch: {
            videoTypeItem() {
                this.isVideoTypeItemsOpened = false;
            },
        },
    }
</script>

<style scoped>
    .text-content {
        width: 55%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .text-context-md-lg-xl {
        align-items: flex-start;
    }
    .text-content-sm-xs {
        align-items: center;
    }
    .title-text-md-lg-xl {
        font-size: clamp(24px, 5vw, 36px);
        line-height: clamp(24px, 5vw, 38.4px);
        color: #ffffff;
    }
    .title-text-sm-xs {
        font-size: clamp(18px, 3vw, 24px);
        line-height: clamp(16px, 3vw, 24px);
        color: #7CDBFF;
    }
    .title-text {
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .sub-title-text-md-lg-xl {
        font-size: 16px;
        font-weight: 600;
        text-align: left;
    }
    .sub-title-text-sm-xs {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
    }
    .sub-title-text {
        color: #E6E6E6;
        font-family: Rajdhani;
        font-style: normal;
        line-height: normal;
    }
    .action-handler-items {
        width: 90%;
        min-width: 390px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 10px;
        padding-right: 10px;
    }
    .action-handler-item {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .blueprint-options {
        width: 100%;
        min-width: 315px;
        min-height: 248px;
        border-radius: 10px;
        background-color: #D5D7D7;
        margin-top: 40px;
        padding: 20px;
    }
    .blueprint-option-title {
        color: #272727;
        font-family: Rajdhani;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }
    .blueprint-options-container {
        width: 45%;
        min-width: 290px;
        height: auto;
    }
    .blueprint-option-item {
        width: 100%;
        height: 50px;
        border-radius: 10px;
        background: #FFFFFF;
        color: #272727;
        font-family: Rajdhani;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
    }
    .blueprint-option-item:first-child {
        position: relative;
    }
    .blueprint-option-item:not(:first-child) {
        cursor: pointer;
    }
    .blueprint-option-item:not(:first-child):hover {
        background-color: #87CEFA;
        border: 2px solid #0000ff;
        font-weight: 700;
        font-size: 18px;
    }
    .selected-blueprint-option {
        background-color: #87CEFA;
        font-weight: 700;
        font-size: 18px;
    }

    .compliance-container {
        background-color: #D9D9D9;
        border-radius: 5px;
    }
    .cmmc-compliance-check {
        background-color: #00AFF7;
        border-radius: 5px;
        padding: 30px;
    }
    .compliance-text {
        color: #FFF;
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .top-compliance-text {
        font-size: 40px;
    }
    .bottom-compliance-text {
        font-size: 20px;
    }

    .course-container-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 10000;
    }

    .course-container-display {
        width: 95%;
        height: 95%;
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border: 2px solid gray;
        z-index: 20000;
    }

    .course-content-iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .close-cource-container {
        position: absolute;
        top: 5px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 5000;
    }

	.close-course-container-button i {
		font-size: 28px;
		color: gray;
	}
</style>